import { render, staticRenderFns } from "./PackageTable.vue?vue&type=template&id=07050460&scoped=true&"
import script from "./PackageTable.vue?vue&type=script&lang=js&"
export * from "./PackageTable.vue?vue&type=script&lang=js&"
import style0 from "./PackageTable.vue?vue&type=style&index=0&id=07050460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07050460",
  null
  
)

export default component.exports